module.exports = __webpack_public_path__ + "img/no_common_word.29d33c1b.png";